import React from "react";

// What the printing says a figure IS, and this study's note on how to read it.
//
// THE SENTENCE IS ABOUT TWO FIGURES AND NAMES NEITHER OF THEM TWICE. Turner
// distributes the sixteen among the planets a pair at a time — "Puer, and
// Rubeus are Figures ascribed to Mars; the first whereof hath Mars benevolent,
// the second malevolent" — so the quote a figure carries is shared with its
// partner, and the note under it says which of the two this one is. Splitting
// the sentence in half to give each figure its own clause would be this site
// writing the book's judgement for it.
//
// `compact` is the hover card: the quote alone, trimmed, with no locator. The
// full form is in the detail panel, and everything the card says is there too.
export default function Nature({ nature, compact = false }) {
  if (!nature) return null;

  if (compact) {
    return (
      <p className="geo-card__nature" data-testid="geo-card-nature">
        “{nature.quote}”
      </p>
    );
  }

  return (
    <figure className="passage passage--nature" data-testid="geo-detail-nature">
      <blockquote className="passage__quote">{nature.quote}</blockquote>
      <figcaption className="passage__source">
        {nature.locator} — in the <cite>Fourth Book of Occult Philosophy</cite>, Robert
        Turner&rsquo;s English, London 1655
      </figcaption>
      <p className="passage__gloss">
        <span className="passage__gloss-label">In plain English</span>
        {nature.note}
      </p>
    </figure>
  );
}
